import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {diasDeAtraso, diasSemPedir, moeda, segmentoCrm, SegmentoCrm} from '../crm-segmentos';
import {MensagemMiaCrmComponent} from '../mensagem-mia-crm/mensagem-mia-crm.component';

const DIAS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

/** Resumo do CRM na ficha do cliente (também aberta ao lado da conversa na extensão V4). */
@Component({
  selector: 'app-resumo-crm-contato',
  standalone: true,
  imports: [CommonModule, MensagemMiaCrmComponent],
  templateUrl: './resumo-crm-contato.component.html',
  styleUrls: ['./resumo-crm-contato.component.scss']
})
export class ResumoCrmContatoComponent {
  @Input() contato: any = null;
  miaAberta = false;

  get temDados(): boolean {
    return !!(this.contato && this.contato.id && this.contato.status);
  }

  get segmento(): SegmentoCrm {
    return segmentoCrm(this.contato && this.contato.status);
  }

  get numeros(): Array<{valor: string; rotulo: string}> {
    const c = this.contato || {};
    const dias = diasSemPedir(c);
    return [
      {valor: dias === null ? '—' : (dias === 0 ? 'hoje' : `${dias}d`), rotulo: 'sem pedir'},
      {valor: c.cicloRecompraDias && c.crmUltimoPedidoEm ? `${c.cicloRecompraDias}d` : '—', rotulo: 'ritmo'},
      {valor: String(Number(c.pedidos90d) || 0), rotulo: 'pedidos 90d'},
      {valor: Number(c.ticketMedio90d) ? moeda(c.ticketMedio90d) : '—', rotulo: 'ticket'}
    ];
  }

  get atraso(): number {
    return diasDeAtraso(this.contato);
  }

  get diasPreferidos(): string {
    const mascara = Number(this.contato && this.contato.crmDiasSemanaMask) || 0;
    return DIAS.filter((_, i) => (mascara & (1 << i)) !== 0).join(', ');
  }
}
